import React from "react";
import {Tooltip} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles"

let Element = props => {
    return props.tooltipinfo ?
        <InfoTooltip interactive title={ props.title }>{ props.children }</InfoTooltip>
        : <Tooltip { ...props }>{ props.children }</Tooltip>
}

export default Element;

let InfoTooltip = withStyles ((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: '280px',
        fontSize: theme.typography.pxToRem (12),
        border: '1px solid #dadde9',
    },
})) (Tooltip);